import cx from 'classnames'

interface ShopFormProgressIndicatorItemProps {
  title?: string
  isSelected?: boolean
  showLine?: boolean
  className?: string
}

const ShopFormProgressIndicatorItem = ({
  title,
  isSelected,
  showLine,
  className,
}: ShopFormProgressIndicatorItemProps) => {
  return (
    <div
      className={cx('relative flex justify-center items-start px-1', className)}
    >
      {showLine && (
        <div
          className={cx('absolute top-2 h-[1px] bg-gray-light z-0')}
          style={{
            left: '-50%',
            right: '50%',
          }}
        />
      )}
      <div className="inline-flex flex-col items-center gap-2 z-10">
        <div
          className={cx('w-4 h-4 rounded-full border mx-auto', {
            'bg-white border-gray-light': !isSelected,
            'bg-red border-black': isSelected,
          })}
        />
        {!!title && (
          <span className="text-md font-medium text-center">{title}</span>
        )}
      </div>
    </div>
  )
}

export default ShopFormProgressIndicatorItem
